import GoogleOAuth2 from 'google-oauth2-web-client';
import {bcTypes} from 'bc/services/bcTypes';
import {get} from 'lodash';

export const doGaAuthFlow = (clientId, createDataSource, me) => {
  let locOrigin = window.location.origin;
  if (locOrigin.indexOf('localhost:') === -1) {
    const baseDnsName = me.baseDNSName === 'anodot-test.com' ? 'ano-dev.com' : me.baseDNSName;
    locOrigin = `https://${me.clusterDNSPrefix}.${baseDnsName}`;
  }

  const go2 = new GoogleOAuth2({
    clientId,
    redirectUri: `${locOrigin}/api/v1/bc/signin/oauth/google/callback`,
    scope:
      // eslint-disable-next-line max-len
      'https://www.googleapis.com/auth/analytics.readonly https://www.googleapis.com/auth/analytics.manage.users.readonly',
    responseType: 'code',
    accessType: 'offline',
    state: me.ownerOrganization || 'no-org-id',
    popupHeight: 600,
    popupWidth: 600,
  });
  go2.login(true, false);

  window.createDataSource = function(token) {
    createDataSource({
      code: token,
      type: bcTypes.google_analytics.type,
      name: `Google Analytics Data Source ${new Date().getTime().toString()}`,
      authenticationType: 'refresh_token',
      redirectURI: `${locOrigin}/api/v1/bc/signin/oauth/google/callback`,
    });
  };
};

export const getEditorValidationMessage = (stream) => {
  if (!stream.accountId) {
    return 'Google analytics account is mandatory';
  }
  if (!stream.propertyId) {
    return 'Google analytics property is mandatory';
  }
  if (!stream.viewId) {
    return 'Google analytics view is mandatory';
  }
  if (stream.delayMinutes > 2880) {
    return 'Maximum delay is 48 hours';
  }
  if (!get(stream, 'metrics.length')) {
    return 'Data stream should have at least one metric';
  }
  if (get(stream, 'dimensions.length') > 7) {
    return 'Data stream can have up to 7 dimension';
  }
  if (get(stream, 'metrics.length') > 10) {
    return 'Data stream can have up to 10 metrics';
  }
  return null;
};
